import WarningIcon from "@icons/warning.svg";
import Image from "next/image";

function NotFoundMessage({ message }: { message: string }): JSX.Element {
  return (
    <div className="rounded-md bg-amber-50 p-4 -m-5">
      <div className="flex items-center">
        <div className="shrink-0">
          <Image src={WarningIcon} height={28} width={28} aria-hidden="true" alt="" />
        </div>
        <div className="ml-5">
          <div className="mt-2 text-sm text-amber-700">
            <p dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundMessage;
